import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import {
  selectCurrentToken,
  selectEmbededToken,
  selectIsEmbed,
  setCredentials,
} from "./authSlice";
import { useNewRefreshTokenMutation } from "./authApiSlice";

export default function RequireEmbedAuth() {
  const isEmbed = useSelector(selectIsEmbed);
  const embededToken = useSelector(selectEmbededToken);
  // console.log(embededToken);

  const dispatch = useDispatch();
  // Get the actual value

  const [
    newRefreshToken,
    {
      data: newRefreshTokenData,
      isError: isNewRefreshTokenError,
      isLoading: isNewRefreshTokenLoading,
      isSuccess: isNewRefreshTokenSuccess,
      error: newRefreshTokenError,
    },
  ] = useNewRefreshTokenMutation();
  useEffect(() => {
    if (isEmbed && embededToken) {
      const refreshInterval = setInterval(async () => {
        // console.log(embededToken);
        const body = {
          embedString: embededToken
        };
        try {
          await newRefreshToken(body).unwrap(); // hit the API
        } catch (err) {
          console.error(err?.data?.message);
        }
      // }, 10000); // 1 minute
      }, 24* 60 * 1000); // 1 minute
      return () => clearInterval(refreshInterval);
    }
  }, [newRefreshToken, embededToken]);
  useEffect(() => {
    if (isNewRefreshTokenSuccess && newRefreshTokenData) {
      // console.log(newRefreshTokenData?.newEmbedToken);
      dispatch(
        setCredentials({
          embededToken: newRefreshTokenData.newEmbedToken,
          isEmbed: true,
        })
      );
    }
  }, [isNewRefreshTokenSuccess, newRefreshTokenData]);
  return <Outlet />;
}
